var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as MT4 from './mt4-types';
export var ConnectorEvent;
(function (ConnectorEvent) {
    ConnectorEvent["CONNECTED"] = "CONNECTED";
    ConnectorEvent["DISCONNECTED"] = "DISCONNECTED";
    ConnectorEvent["POSITIONS_UPDATE"] = "POSITIONS_UPDATE";
    ConnectorEvent["PRICES_UPDATE"] = "PRICES_UPDATE";
})(ConnectorEvent || (ConnectorEvent = {}));
export var FeedEvent = __assign(__assign({}, ConnectorEvent), MT4.Event);
export var BondBuyMode;
(function (BondBuyMode) {
    BondBuyMode["BOND_BUY_MODE_CASH"] = "BOND_BUY_MODE_CASH";
    BondBuyMode["BOND_BUY_MODE_PRINCIPAL"] = "BOND_BUY_MODE_PRINCIPAL";
})(BondBuyMode || (BondBuyMode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXQ0LWNvbm5lY3Rvci10eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tdDQtY29ubmVjdG9yLXR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEdBQUcsTUFBTSxhQUFhLENBQUE7QUFZbEMsTUFBTSxDQUFOLElBQVksY0FLWDtBQUxELFdBQVksY0FBYztJQUN4Qix5Q0FBdUIsQ0FBQTtJQUN2QiwrQ0FBNkIsQ0FBQTtJQUM3Qix1REFBcUMsQ0FBQTtJQUNyQyxpREFBK0IsQ0FBQTtBQUNqQyxDQUFDLEVBTFcsY0FBYyxLQUFkLGNBQWMsUUFLekI7QUFHRCxNQUFNLENBQUMsSUFBTSxTQUFTLHlCQUNqQixjQUFjLEdBQ2QsR0FBRyxDQUFDLEtBQUssQ0FDYixDQUFBO0FBcUNELE1BQU0sQ0FBTixJQUFZLFdBR1g7QUFIRCxXQUFZLFdBQVc7SUFDckIsd0RBQXlDLENBQUE7SUFDekMsa0VBQW1ELENBQUE7QUFDckQsQ0FBQyxFQUhXLFdBQVcsS0FBWCxXQUFXLFFBR3RCIn0=